/**
 *
 */
export var ValidationStatus;
(function (ValidationStatus) {
    ValidationStatus[ValidationStatus["WARNING"] = 4] = "WARNING";
    ValidationStatus[ValidationStatus["DISABLED"] = 3] = "DISABLED";
    ValidationStatus[ValidationStatus["ERROR"] = 2] = "ERROR";
    ValidationStatus[ValidationStatus["SUCCESS"] = 1] = "SUCCESS";
    ValidationStatus[ValidationStatus["DEFAULT"] = 0] = "DEFAULT";
})(ValidationStatus || (ValidationStatus = {}));
